import { inject } from '@angular/core';
import { type CanMatchFn, Router } from '@angular/router';

import { StorageService } from '@chefami-monorepo/data-access';

import { SiteStorage } from '../constants/global';
import type { GiftCardDetails } from '../interfaces/gift-card';

/**
 * Route guard that ensures gift card details (with a selected `type`)
 * exist in sessionStorage before allowing access to the payment page.
 *
 * Redirects to `/purchase` when the prerequisite data is missing.
 */
export const pageGuard: CanMatchFn = () => {
  const storage = inject(StorageService);
  const router = inject(Router);

  const details = storage.getItem<GiftCardDetails>(
    SiteStorage.GIFTCARDDETAILS,
    true,
  );

  if (details?.type !== undefined && details.type !== null) {
    return true;
  }

  return router.createUrlTree(['/purchase']);
};
